import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-summary',
    templateUrl: './summary.component.html',
    standalone: false
})
export class SummaryComponent implements OnInit {
  @Input()
  public summary;

  constructor() {}

  ngOnInit(): void {}
}
